<template>
  <div class="compound public-content">
    <div class="breadcrumb">
      尺寸类型管理</div>
    <div class="add-category">
      <div class="keywords">
        <span>关键词:</span>
        <el-input v-model="keywords"></el-input>
      </div>
      <div>
        <el-button round type="primary" @click="addComposeType">新建合成类型</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="composeTypeList" border style="width: 100%">
          <el-table-column prop="typeName" label="合成类型" min-width="180">
          </el-table-column>
          <el-table-column label="操作" min-width="180">
            <template v-slot="scope">
              <span class="color-blue" @click="changeComposeType(0, scope.row)">编辑</span>
              <span class="color-blue" @click="deleteComposeType(scope.row)" style="margin: 0 5px">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <CombinedDialog ref="dialogRef" @delete="deleteComposeTypeOK" @addComposeType="addComposeTypeOK"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index'
import { composeTypeListPaging } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    CombinedDialog,
    VPagination
  },
  data () {
    return {
      composeTypeList: [],
      keywords: '',
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.getComposeType(this.queryInfo)
  },
  methods: {
    getComposeType (val) {
      composeTypeListPaging({ pageNum: val.pageNum, pageSize: val.pageSize }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.composeTypeList = res.data.data.records
        } else {
        }
      })
    },
    addComposeType () {
      this.$refs.dialogRef.show('addComposeType', '新建合成类型')
    },
    changeComposeType (item, row) {
      this.$refs.dialogRef.show('addComposeType', '编辑合成类型', '', '', '', row)
    },
    deleteComposeType (content) {
      this.$refs.dialogRef.show('delete', '确定提示', '删除确定<br><span style="color: #999">是否确定删除</span>',
        '', 'post', '/api/pms/admin/compose/type/delete/' + `${content.id}`)
    },
    changePage (val) {
      this.queryInfo = val
      this.getComposeType(this.queryInfo)
    },
    addComposeTypeOK () {
      this.getComposeType(this.queryInfo)
    },
    deleteComposeTypeOK () {
      this.getComposeType(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }
  .keywords {
    display: flex;
    justify-content: space-around;
    width: 250px;
    align-items: center;
    .el-input {
      width: 180px;
    }
  }
}
</style>
